enum VendaEntregaStatus {
    Entregue = 1,
    NaoEntregue = 2,
}
export default VendaEntregaStatus;
